export default __webpack_public_path__ + "static/media/LT.201ea2e5.svg";